import React, { useContext, useCallback, useState } from 'react'
import styled from 'styled-components'
import { device } from 'utils/device'
import { I18nContext } from 'i18n'
import { DownloadScholarshipsModal, ProgramEditModal, PreUploadModal } from 'components'
import { useAlert } from 'react-alert'
import { navigate, Link } from 'raviger'
import { reactLocalStorage } from 'reactjs-localstorage'

const DataCenterActions = ({ getStagedCount }) => {
  const { translate } = useContext(I18nContext)
  const alert = useAlert()
  const [showDownload, setShowDownload] = useState(false)
  const [showUpload, setShowUpload] = useState(false)
  const [showNewProgram, setShowNewProgram] = useState(false)
  const { organization } = reactLocalStorage.getObject('user')
  const actions = [
    'add',
    'download',
    'edit',
    'help',
    'upload',
    'view_added',
    'view_programs',
  ]

  const handleActionClick = useCallback((action) => {
    switch (action) {
      case 'download':
        setShowDownload(true)
        break
      case 'upload':
        setShowUpload(true)
        break
      case 'view_programs':
      case 'edit':
        navigate('/data-center/programs')
        break
      case 'view_added':
        navigate('/data-center/program-updates')
        break
      case 'add':
        setShowNewProgram(true)
        break
      case 'help':
        navigate('/data-center/help-info')
        break
      default:
        alert.info('Feature to Come, Not Yet Implemented')
        break
    }
  }, [setShowDownload, setShowUpload])

  const handleHide = (message) => {
    setShowNewProgram(false)
    if (message) {
      alert.success(message)
      getStagedCount()
    }
  }

  return (
    <Container className="container">
      <h2>Actions</h2>
      <p>
        Things you can do on this site. Click on a link below and we'll take you
        to the right place. Want to learn more before jumping in? View the
        helpful and informative <Link href="/data-center/help-info">Help & Info</Link>.
      </p>
      <List className="p-0">
        {actions.map((action) => (
          <li key={`home-action-${action}`}>
            <button onClick={() => handleActionClick(action)}>
              {translate(`home_action_${action}`)}
            </button>
          </li>
        ))}
      </List>
      {showDownload && (
        <DownloadScholarshipsModal show onHide={() => setShowDownload(false)} />
      )}

      <PreUploadModal show={showUpload} setShow={setShowUpload} onHide={() => setShowUpload(false)} />

      {showNewProgram && (
        <ProgramEditModal
          show
          onHide={handleHide}
          action="edit"
          toolbar
          organization={organization}
        />
      )}
    </Container>
  )
}

const List = styled.ul`
  list-style: none;

  > li > button {
    color: ${({ theme }) => theme.palette.primary[3]};
    background-color: transparent;
    border: none;
    font-size: 0.9rem;
    padding: 0.3rem 0;

    &:hover {
      text-decoration: underline;
    }

    &:focus {
      outline: none;
    }
  }
`

const Container = styled.div`
  width: 70%;
  margin: 2rem auto;
  color: ${({ theme }) => theme.palette.grayscale[2]};

  > p {
    max-width: 25rem;
    font-size: 0.9rem;
    font-weight: 100;

    a {
      color: ${({ theme }) => theme.palette.primary[3]};
      font-weight: 400;
    }
  }

  @media ${device.mobileL} {
    width: 80%;
    padding: 0;
    margin-top: 0;
  }
`

export default DataCenterActions
